// Fester Rückgabesatz statt Datum auf den Domains, deren Merchant-Konto wegen Falschdarstellung gesperrt ist (Finn 22.10.2026). Andere Hosts: Datum wie bisher.
window.FL_RET_FEST=(function(){try{var h=location.hostname.split(".").pop();return {dk:"30 dages returret fra modtagelse af varen",nl:"30 dagen retourrecht na ontvangst van de goederen",fr:"Droit de retour de 30 jours à compter de la réception de la marchandise",it:"Diritto di reso di 30 giorni dal ricevimento della merce",se:"30 dagars returrätt från mottagandet av varan",at:"30 Tage Rückgaberecht ab Erhalt der Ware"}[h]||null}catch(e){return null}})();
// setTimeout(function(){
//   fetch('https://new-era.io/api/v2/average/stats/today?number=7')
//   .then(res => res.json())
//   .then(data => {
//     const zittauSum = data.data.zittau.reduce((a,b) => a + b.average, 0);
//     const halleSum = data.data.halle.reduce((a,b) => a + b.average, 0);
//     const sevenDaysAvg = Math.floor(((zittauSum / 7) + (halleSum / 7))/2);
//   	if(sevenDaysAvg > 23){
//             document.getElementById("arrival-days").innerHTML = '• Versandzeit ca. 2-4 Wochen';
//         }else if (sevenDaysAvg > 14 && sevenDaysAvg < 24){
//             document.getElementById('arrival-days').innerHTML = '• Versandzeit ca. 2-3 Wochen';
//         }else if (sevenDaysAvg > 9 && sevenDaysAvg < 15){
//             document.getElementById('arrival-days').innerHTML = '• Versandzeit ca. 1-2 Wochen';
//         }else if (sevenDaysAvg > 5 && sevenDaysAvg < 10){
//             document.getElementById('arrival-days').innerHTML = '• Versandzeit ca. 3-5 Tage';
//         }else if (sevenDaysAvg > 0 && sevenDaysAvg < 6){
//             document.getElementById('arrival-days').innerHTML = '• Versandzeit ca. 1-3 Tage';
//         }
//   })
//   .catch(e => console.error(e));

// }, 200);

const germanDates_ = {
monday: 'Montag',
tuesday: 'Dienstag',
wednesday: 'Mittwoch',
thursday: 'Donnerstag',
friday: 'Freitag',
saturday: 'Samstag',
sunday: 'Sonntag'
}

const germanMonths = {
january: 'Januar',
february: 'Februar',
march: 'März',
april: 'April',
may: 'Mai',
june: 'Juni',
july: 'Juli',
august: 'August',
september: 'September',
october: 'Oktober',
november: 'November',
december: 'Dezember'
}

function getGermanDate(date) {
if (date == 'Mon') {
  date = germanDates_.monday
}
else if (date == 'Tue') {
  date = germanDates_.tuesday
}
else if (date == 'Wed') {
  date = germanDates_.wednesday
}
else if (date == 'Thu') {
  date = germanDates_.thursday
}
else if (date == 'Fri') {
  date = germanDates_.friday
}
else if (date == 'Sat') {
  date = germanDates_.saturday
}
else if (date == 'Sun') {
  date = germanDates_.sunday
}
return date
}

function getGermanMonth(date) {
if (date == 'Jan') {
  date = germanMonths.january
}
else if (date == 'Feb') {
  date = germanMonths.february
}
else if (date == 'Mar') {
  date = germanMonths.march
}
else if (date == 'Apr') {
  date = germanMonths.april
}
else if (date == 'May') {
  date = germanMonths.may
}
else if (date == 'Jun') {
  date = germanMonths.june
}
else if (date == 'Jul') {
  date = germanMonths.july
}
else if (date == 'Aug') {
  date = germanMonths.august
}
else if (date == 'Sep') {
  date = germanMonths.september
}
else if (date == 'Oct') {
  date = germanMonths.october
}
else if (date == 'Nov') {
  date = germanMonths.november
}
else if (date == 'Dec') {
  date = germanMonths.december
}
return date
}

const currentDate = new Date();
currentDate.setDate(currentDate.getDate() + 30)
const currentDateArr = currentDate.toUTCString().split(" ").slice(0, 3);

setTimeout(function () {
function getDateFromHours(time) {
  time = time.split(':');
  let now = new Date();
  return new Date(now.getFullYear(), now.getMonth(), now.getDate(), ...time);
}

const currentTime = new Date().toTimeString().split(" ")[0]
const referentTime = '13:00:00';
const hours = getDateFromHours(referentTime).getHours();
if ((getDateFromHours(referentTime) - getDateFromHours(currentTime)) > 0) {
const _rp = document.getElementById("return-policy"); if (_rp) _rp.innerHTML = window.FL_RET_FEST || `Rücksendung bis ${getGermanDate(currentDateArr[0].replace(',', ''))}, ${currentDateArr[1]} ${getGermanMonth(currentDateArr[2])} möglich`; //aaaaaaaa
console.log(`Rücksendung bis ${getGermanDate(currentDateArr[0].replace(',', ''))}, ${currentDateArr[1]} ${getGermanMonth(currentDateArr[2])} möglich`); //aaaaaaaa
  const timeLeft = getDateFromHours(referentTime) - getDateFromHours(currentTime);
  const date = new Date(timeLeft);
  const h = (date.getHours() + 24).toString();
  let timeLeftMinutes = (timeLeft / 1000) / 60;
  let minuteGerman = (timeLeftMinutes == 1) ? 'Minute' : 'Minuten';
  if (timeLeftMinutes > 60) {
      const timeLeftHours = Math.floor(timeLeftMinutes / 60);
      timeLeftMinutes = Math.floor(((timeLeftMinutes / 60) - timeLeftHours) * 60);
      let hourGerman = timeLeftHours == 1 ? 'Stunde' : 'Stunden';
      minuteGerman = timeLeftMinutes == 1 ? 'Minute' : 'Minuten';
//             document.getElementById("arrival-days-date").innerHTML = `${getGermanDate(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[0].split(',')[0])}, ${getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[1]} ${getGermanMonth(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[2])}`;
//             document.getElementById("arrival-days-time").innerHTML = `${timeLeftHours} ${hourGerman} und ${timeLeftMinutes} ${minuteGerman}.`
  }
  else {
//             document.getElementById("arrival-days-date").innerHTML = `${getGermanDate(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[0].split(',')[0])}, ${getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[1]} ${getGermanMonth(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[2])}`;
//             document.getElementById("arrival-days-time").innerHTML = `${Math.floor(timeLeftMinutes)} ${minuteGerman}.`
  }
}
else {
 if(document.querySelector("#return-policy")){
  
const _rp = document.getElementById("return-policy"); if (_rp) _rp.innerHTML = window.FL_RET_FEST || `Rücksendung bis ${getGermanDate(currentDateArr[0].replace(',', ''))}, ${currentDateArr[1]} ${getGermanMonth(currentDateArr[2])} möglich`; //aaaaaaaa
  const endOfDay = new Date().setHours(24, 0);
  const timeLeft = endOfDay - getDateFromHours(currentTime)
  const date = new Date(timeLeft);
  const h = (date.getHours() + 48).toString();
  let timeLeftMinutes = ((timeLeft / 1000) / 60);
  let minuteGerman = timeLeftMinutes == 1 ? 'Minute' : 'Minuten';
  if (timeLeftMinutes > 60) {
      const timeLeftHours = Math.floor(timeLeftMinutes / 60);
      timeLeftMinutes = Math.floor(((timeLeftMinutes / 60) - timeLeftHours) * 60);
      let hourGerman = timeLeftHours == 1 ? 'Stunde' : 'Stunden';
      minuteGerman = timeLeftMinutes == 1 ? 'Minute' : 'Minuten';
//             document.getElementById("arrival-days-date").innerHTML = `${getGermanDate(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[0].split(',')[0])}, ${getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[1]} ${getGermanMonth(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[2])}`;
//             document.getElementById("arrival-days-time").innerHTML = `${timeLeftHours + hours} ${hourGerman} und ${timeLeftMinutes} ${minuteGerman}.`
  }
  else {
//             document.getElementById("arrival-days-date").innerHTML = `${getGermanDate(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[0].split(',')[0])}, ${getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[1]} ${getGermanMonth(getDateFromHours(h).toUTCString().split(" ").slice(0, 3).join(' ').split(" ")[2])}`;
//             document.getElementById("arrival-days-time").innerHTML = `${Math.floor(timeLeftMinutes)} ${minuteGerman}.`
  }
}
}
}, 1000);

/* FL-NEWSLETTER-IMG */
(function(){
  function p(){
    var f=document.querySelector('.klaviyo-form-XvRLkw');
    if(!f) return false;
    var s=f.closest('.section-blends') || f.closest('[id^="shopify-section-"]');
    if(!s || s.dataset.flNewsImg) return true;
    s.dataset.flNewsImg='1';
    s.classList.add('fl-news-flex');
    var i=document.createElement('img');
    i.src='https://cdn.shopify.com/s/files/1/0068/9219/1844/files/ugc_kitchen_pink_2.webp?width=520';
    i.alt=''; i.loading='lazy'; i.className='fl-news-img';
    s.insertBefore(i, s.firstChild);
    return true;
  }
  if(!p()){
    var m=new MutationObserver(function(){ if(p()) m.disconnect(); });
    if(document.body) m.observe(document.body,{childList:true,subtree:true});
    setTimeout(function(){ m.disconnect(); }, 15000);
  }
})();
/* FL-LANG-BANNER */
/* Das fuehrende Semikolon unten ist Absicht: es trennt diesen Block von dem
   darueber, falls der einmal ohne abschliessendes ";" endet. Siehe Zeile 217. */
;(function(){
  /* 27.09.2026: Das Ziel kommt aus Shopifys eigenen Sprachverweisen dieser Seite
     (link rel=alternate hreflang), nicht mehr aus einer eigenen Pfadliste. Die Liste
     kannte /fr-be, /nl-be und /de-at nicht: Auf /fr-be/... galt die Seite als deutsch,
     der Banner bot einem franzoesischen Handy Franzoesisch an und setzte /fr-fr vor den
     ganzen Pfad. Heraus kam /fr-fr/fr-be/..., eine 404-Seite: 239 Aufrufe vom 20. bis
     27.09., drei Viertel aus dem Facebook- und Instagram-Browser, also aus den
     Belgien-Anzeigen. Die Verweise kennen jeden Markt und jede uebersetzte Adresse
     (Produkte in /da-dk haben eigene Namen); ohne Verweis erscheint kein Banner. */
  var TXT={
    de:{f:'🇩🇪',m:'Diese Seite ist auch auf Deutsch verfügbar.',y:'Auf Deutsch ansehen'},
    it:{f:'🇮🇹',m:'Questo sito è disponibile anche in italiano.',y:'Passa all’italiano'},
    fr:{f:'🇫🇷',m:'Ce site est aussi disponible en français.',y:'Voir en français'},
    es:{f:'🇪🇸',m:'Este sitio también está disponible en español.',y:'Ver en español'},
    nl:{f:'🇳🇱',m:'Deze site is ook beschikbaar in het Nederlands.',y:'Naar het Nederlands'},
    pl:{f:'🇵🇱',m:'Ta strona jest również dostępna po polsku.',y:'Pokaż po polsku'},
    da:{f:'🇩🇰',m:'Denne side findes også på dansk.',y:'Skift til dansk'},
    sv:{f:'🇸🇪',m:'Den här sidan finns även på svenska.',y:'Byt till svenska'}
  };
  if(document.cookie.indexOf('fl_lang_pref=')>-1) return;
  var voll=(navigator.language||navigator.userLanguage||'de').toLowerCase();
  var nav=voll.slice(0,2);
  if(!TXT[nav]) return;
  /* Welche Sprache die Seite hat, sagt Shopify im lang-Attribut, nicht der Pfad. */
  var CUR=(document.documentElement.getAttribute('lang')||'de').slice(0,2).toLowerCase();
  if(nav===CUR) return;
  var verweise=document.querySelectorAll('link[rel="alternate"][hreflang]'), passend=[], i;
  for(i=0;i<verweise.length;i++){
    var hl=(verweise[i].getAttribute('hreflang')||'').toLowerCase(), url=verweise[i].getAttribute('href');
    if(url&&hl.slice(0,2)===nav) passend.push({hl:hl,url:url});
  }
  if(!passend.length) return;
  /* Welcher Markt: derselbe wie diese Seite (wer ueber /nl-be kam, bleibt in Belgien),
     sonst der genaue Browser-Markt, sonst der erste Verweis dieser Sprache. */
  var land=(location.pathname.match(/^\/[a-z]{2}-([a-z]{2})(\/|$)/)||[])[1]||'', wahl=null;
  for(i=0;i<passend.length&&!wahl;i++) if(land&&passend[i].hl.slice(3)===land) wahl=passend[i];
  for(i=0;i<passend.length&&!wahl;i++) if(passend[i].hl===voll) wahl=passend[i];
  if(!wahl) wahl=passend[0];
  /* Der Verweis traegt selbst schon Parameter wie ?page=2 oder ?q=lack; die der Anzeige (utm,
     fbclid) kommen nur dazu, wenn er sie nicht hat. Angehaengt ergab das ?page=2?page=2. */
  var target=wahl.url;
  try{var ziel=new URL(wahl.url,location.href),hier=new URLSearchParams(location.search);
    hier.forEach(function(w,k){if(!ziel.searchParams.has(k))ziel.searchParams.append(k,w);});
    target=ziel.href;}catch(e){}
  function setPref(){document.cookie='fl_lang_pref=1; path=/; max-age=15552000';}
  /* 27.09.2026 (Finn: "wenn ich auf Auf Deutsch ansehen klicke, passiert nichts"): Ein einfacher Link reicht nicht.
     Wer schon in einem Markt war, traegt den Keks localization=IT, und der Shop biegt jeden Link auf die Seite dieses
     Marktes zurueck: Der Klick lud dieselbe italienische Seite neu. Sprache und Land wechselt Shopify nur ueber sein
     Formular /localization (wie der Sprachwaehler im Theme); danach geht es zur Zieladresse. Der Link bleibt als Rueckfall. */
  function wechsle(){
    try{
      var z=new URL(target,location.href), teile=wahl.hl.split('-');
      var felder={form_type:'localization',utf8:'\u2713',_method:'put',return_to:z.pathname+z.search,
        language_code:teile[0],country_code:(teile[1]||'de').toUpperCase()};
      var f=document.createElement('form'); f.method='post'; f.action='/localization'; f.setAttribute('accept-charset','UTF-8');
      for(var k in felder){var e=document.createElement('input'); e.type='hidden'; e.name=k; e.value=felder[k]; f.appendChild(e);}
      document.body.appendChild(f); f.submit(); return true;
    }catch(e){return false;}
  }
  function build(){
    var t=TXT[nav];
    var bar=document.createElement('div'); bar.id='fl-lang-banner';
    var flag=document.createElement('div'); flag.className='flb-flag'; flag.textContent=t.f;
    var body=document.createElement('div'); body.className='flb-body';
    var msg=document.createElement('span'); msg.className='flb-msg'; msg.textContent=t.m;
    var yes=document.createElement('a'); yes.className='flb-yes'; yes.href=target; yes.textContent=t.y; yes.addEventListener('click',function(ev){setPref(); if(wechsle()&&ev&&ev.preventDefault) ev.preventDefault();});
    var arr=document.createElement('span'); arr.className='flb-arr'; arr.textContent='→'; yes.appendChild(arr);
    body.appendChild(msg); body.appendChild(yes);
    var x=document.createElement('button'); x.className='flb-x'; x.setAttribute('aria-label','close'); x.textContent='✕'; x.addEventListener('click',function(){setPref(); if(bar.parentNode) bar.parentNode.removeChild(bar);});
    bar.appendChild(flag); bar.appendChild(body); bar.appendChild(x);
    document.body.appendChild(bar);
    setTimeout(function(){bar.classList.add('flb-in');},60);
  }
  if(document.body) build(); else document.addEventListener('DOMContentLoaded',build);
})();
